import { ColorPickerBottomModal } from "components/modules/Editors/MemeGenerator/common/ColorPickerBottomModal/ColorPickerBottomModal";
import { ColorPickerButtonContainer } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/ColorList/ColorPickerButton/ColorPickerButtonContainer";
import { Mode } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Color/types";
import { TextBox } from "store/features/memeGenerator/types";
import { useColorPickerButton } from "./useColorPickerButton";

interface ColorPickerButtonProps {
    textBox: TextBox;
    mode: Mode;
}

export const ColorPickerButton = ({ textBox, mode }: ColorPickerButtonProps) => {
    const { color, setColor, isOpen, close, approve, toggle } = useColorPickerButton(textBox, mode);
    return (
        <>
            <ColorPickerButtonContainer
                isActive={getIsColorPickerButtonActive(textBox, mode, color)}
                onClick={toggle}
            />
            <ColorPickerBottomModal
                color={color}
                setColor={setColor}
                isOpen={isOpen}
                onClose={close}
                containerId="mobile-color-picker-modal"
                initialHeight="331px"
                title="Select Color"
                onApprove={approve}
            />
        </>
    );
};

function getIsColorPickerButtonActive(textBox: TextBox, mode: Mode, color: string) {
    switch (mode) {
        case "text":
            return textBox.fontColor === color;
        case "shadow":
            return textBox.shadow?.color === color;
        case "outline":
            return textBox.outline?.color === color;
        default:
            let _: never = mode;
            throw new Error("Invalid mode");
    }
}
